<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    @click="$emit('click')"
  >
    <path
      d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"
    />
    <title>{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "DeleteIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
